import type { FaireProductEntity } from "../../entity_types/product";

export const p_rc762s39sq: FaireProductEntity = {
  token: "p_rc762s39sq",
  type: "product",
  name: "Spring Bunny Kitchen Towel",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/2ac1a48ed40d57e13cb15e9c5807e33ffc988efec727ccdeccfc6b7d75bd9a05.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fa0d0a3a44f4e9caa21a9d99a7a0ee8809e012fafad879f411b5a5a71f1e26c4.jpeg",
    "https://cdn.faire.com/fastly/5dc3b10b0d07549adf125d88ac82184019237d6c6e72e89a0cad01e699c3dcc7.jpeg",
    "https://cdn.faire.com/fastly/3f54257b7c131323498604fdd2461bbff401fecd071b990d33b714c2f7ae0e8b.jpeg",
    "https://cdn.faire.com/fastly/5ee2da097d720ec60152d9d9a2f9a0fdb8d86358dfff692d1891db47fc37ab8f.jpeg",
    "https://cdn.faire.com/fastly/aa2df713db3b7520dda6ab76486a819a347f4fd3baa959853521db2b6cf6dee6.jpeg",
    "https://cdn.faire.com/fastly/2f930a1ebe18a9b412a64365b1571e66fa62105db964315fae3d5e7ca22f4aa3.jpeg"
  ],
  priceDollars: 8,
  description: "A microfiber kitchen towel from our Easter & Spring Collection featuring an all-over design displaying a charming scene of bunnies in a field of spring flowers. The spring bunny design is replicated from original artwork painted onto burlap canvas, giving the art a unique depth and texture. Double-sided towel displays a coordinating stripe pattern on the back that offers multiple display options with a cotton tape hanger in the corner for hanging. Our Spring Bunny kitchen towel is conveniently machine washable for easy cleaning. Spring towel is packaged on a cardboard hanger with hole to easily display on store rack. A spring-themed kitchen accessory that easily adds seasonal style to any kitchen.",
  tags: [],
  msrpDollars: 15.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:23.794Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
